import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  border-radius: 12px 12px 0px 0px;
  padding: 16px;
  background-color: ${colors.primary};

  @media (max-width: 765px) {
    flex-direction: column;
    height: 100px;
    gap: 16px;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px 0;
  }
`

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 150px;
  width: 100%;
  
  @media (max-width: 765px) {
    justify-content: left;
    margin: 0 16px;
  }
`

export const SelectContainer = styled.div`
  min-width: 220px;
  margin-left: 16px;
`

export const Input = styled.input`
  width: 100%;
  max-width: 390px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid ${colors.softGray};
  &:focus {
    border-color: ${colors.primary};
    outline: none;
  }
  ::placeholder {
    color: ${colors.strongGray};
  }
  color: ${colors.titleStrongBlack};
  font-size: 16px;
  box-sizing: border-box;
  padding-left: 16px;
`

export const Button = styled.button`
  padding: 8px 16px;
  background-color: ${colors.primary};
  border: none;
  border-radius: 24px;
  cursor: pointer;
  color: ${colors.background};
  font-weight: 600;

  &:hover {
    background-color: ${colors.primary};
  }
`

export const SearchIcon = styled.button`
  cursor: pointer;
  color: ${colors.background};
  padding: 8px 16px;
  background-color: ${colors.primary};
  border: none;
  border-radius: 24px;
  cursor: pointer;
  color: ${colors.background};
  font-weight: 600;

  &:hover {
    background-color: ${colors.primary};
  }
`
